import { apiDelete, apiGet, apiPatch, apiPost, apiPut } from '@/shared/utils/requestBuilder';
import type {
  CreatePartePayload,
  ParteListItem,
  UpdatePartePayload,
} from '@/types/processos/parteStoreTypes';

export const partesService = {
  listar: async (execucaoId: string) => {
    const response = await apiGet(`/partes?execucaoId=${execucaoId}`);
    if (!response.ok) throw new Error('Erro ao listar partes');
    const body = await response.json();
    return body.data as ParteListItem[];
  },
  criar: async (payload: CreatePartePayload) => {
    const response = await apiPost(`/partes`, payload);
    if (!response.ok) throw new Error('Erro ao criar parte');
    const body = await response.json();
    return body.data as ParteListItem;
  },
  atualizar: async (id: string, dados: UpdatePartePayload['dados']) => {
    const response = await apiPut(`/partes/${id}`, dados);
    if (!response.ok) throw new Error('Erro ao atualizar parte');
    const body = await response.json();
    return body.data as ParteListItem;
  },
  remover: async (id: string) => {
    const response = await apiDelete(`/partes/${id}`);
    if (!response.ok) throw new Error('Erro ao remover parte');
  },
  patchOrdem: async (id: string, ordem: number) => {
    const response = await apiPatch(`/partes/${id}/ordem`, { ordem });
    if (!response.ok) throw new Error('Erro ao atualizar ordem da parte');
    const body = await response.json();
    return body.data as ParteListItem;
  },
};
